(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["moon-phase-picker"] && !Shopify.designMode) return;
  try {
    (function () {

    var DEG = Math.PI / 180;

    /**
     * Jour Julien à midi UTC pour une date locale.
     * Jean Meeus, "Astronomical Algorithms", chap. 7.
     */
    function dateToJD(date) {
      var Y = date.getFullYear();
      var M = date.getMonth() + 1;
      var D = date.getDate() + 0.5;
      if (M <= 2) { Y -= 1; M += 12; }
      var A = Math.floor(Y / 100);
      var B = 2 - A + Math.floor(A / 4);
      return Math.floor(365.25 * (Y + 4716))
           + Math.floor(30.6001 * (M + 1))
           + D + B - 1524.5;
    }

    /**
     * Calcul haute précision des données lunaires.
     * Basé sur Jean Meeus, chap. 47 & 48.
     * Retourne { age, illumination, phase, elongation }
     */
    function getMoonData(date) {
      var JD = dateToJD(date);
      var T  = (JD - 2451545.0) / 36525.0;
      var T2 = T * T;
      var T3 = T2 * T;
      var T4 = T3 * T;

      // --- Éléments orbitaux de la Lune ---
      // Longitude moyenne (deg)
      var Lp = 218.3164477
             + 481267.88123421 * T
             - 0.0015786 * T2
             + T3 / 538841.0
             - T4 / 65194000.0;

      // Anomalie moyenne du Soleil (deg)
      var M = 357.5291092
            + 35999.0502909 * T
            - 0.0001536 * T2
            + T3 / 24490000.0;

      // Anomalie moyenne de la Lune (deg)
      var Mp = 134.9633964
             + 477198.8675055 * T
             + 0.0087414 * T2
             + T3 / 69699.0
             - T4 / 14712000.0;

      // Argument de latitude (deg)
      var F = 93.2720950
            + 483202.0175233 * T
            - 0.0036539 * T2
            - T3 / 3526000.0
            + T4 / 863310000.0;

      // Élongation moyenne (deg)
      var D = 297.8501921
            + 445267.1114034 * T
            - 0.0018819 * T2
            + T3 / 545868.0
            - T4 / 113065000.0;

      // Excentricité de l'orbite terrestre
      var E  = 1.0 - 0.002516 * T - 0.0000074 * T2;
      var E2 = E * E;

      // --- Corrections de longitude (1/1000000 deg) ---
      var dL = 0;
      dL +=  6288774 * Math.sin(Mp * DEG);
      dL +=  1274027 * Math.sin((2*D - Mp) * DEG);
      dL +=   658314 * Math.sin(2*D * DEG);
      dL +=   213618 * Math.sin(2*Mp * DEG);
      dL -=   185116 * E  * Math.sin(M * DEG);
      dL -=   114332 * Math.sin(2*F * DEG);
      dL +=    58793 * Math.sin((2*D - 2*Mp) * DEG);
      dL +=    57066 * E  * Math.sin((2*D - M - Mp) * DEG);
      dL +=    53322 * Math.sin((2*D + Mp) * DEG);
      dL +=    45758 * E  * Math.sin((2*D - M) * DEG);
      dL -=    40923 * E  * Math.sin((M - Mp) * DEG);
      dL -=    34720 * Math.sin(D * DEG);
      dL -=    30383 * E  * Math.sin((M + Mp) * DEG);
      dL +=    15327 * Math.sin((2*D - 2*F) * DEG);
      dL -=    12528 * Math.sin((Mp + 2*F) * DEG);
      dL +=    10980 * Math.sin((Mp - 2*F) * DEG);
      dL +=    10675 * Math.sin((4*D - Mp) * DEG);
      dL +=    10034 * Math.sin(3*Mp * DEG);
      dL +=     8548 * Math.sin((4*D - 2*Mp) * DEG);
      dL -=     7888 * E  * Math.sin((2*D + M - Mp) * DEG);
      dL -=     6766 * E  * Math.sin((2*D + M) * DEG);
      dL -=     5163 * Math.sin((D - Mp) * DEG);
      dL +=     4987 * E  * Math.sin((D + M) * DEG);
      dL +=     4036 * E  * Math.sin((2*D - M + Mp) * DEG);
      dL +=     3994 * Math.sin((2*D + 2*Mp) * DEG);
      dL +=     3861 * Math.sin(4*D * DEG);
      dL +=     3665 * Math.sin((2*D - 3*Mp) * DEG);
      dL -=     2689 * E  * Math.sin((M - 2*Mp) * DEG);
      dL -=     2602 * Math.sin((2*D - Mp + 2*F) * DEG);
      dL +=     2390 * E2 * Math.sin((2*D - 2*M - Mp) * DEG);
      dL -=     2348 * Math.sin((D + Mp) * DEG);
      dL +=     2236 * E2 * Math.sin((2*D - 2*M) * DEG);
      dL -=     2120 * E  * Math.sin((M + 2*Mp) * DEG);
      dL -=     2069 * E2 * Math.sin(2*M * DEG);
      dL +=     2048 * E2 * Math.sin((2*D - 2*M + Mp) * DEG);
      dL -=     1773 * Math.sin((2*D + Mp - 2*F) * DEG);
      dL -=     1595 * Math.sin((2*D + 2*F) * DEG);
      dL +=     1215 * E  * Math.sin((4*D - M - Mp) * DEG);
      dL -=     1110 * Math.sin((2*Mp + 2*F) * DEG);
      dL -=      892 * Math.sin((3*D - Mp) * DEG);
      dL -=      810 * E  * Math.sin((2*D + M + Mp) * DEG);
      dL +=      759 * E  * Math.sin((4*D - M - 2*Mp) * DEG);
      dL -=      713 * E2 * Math.sin((2*M - Mp) * DEG);
      dL -=      700 * E2 * Math.sin((2*D + 2*M - Mp) * DEG);
      dL +=      691 * E  * Math.sin((2*D + M - 2*Mp) * DEG);
      dL +=      596 * E  * Math.sin((2*D - M - 2*F) * DEG);
      dL +=      549 * Math.sin((4*D + Mp) * DEG);
      dL +=      537 * Math.sin(4*Mp * DEG);
      dL +=      520 * E  * Math.sin((4*D - M) * DEG);
      dL -=      487 * Math.sin((D - 2*Mp) * DEG);
      dL -=      399 * E  * Math.sin((2*D + M - 2*F) * DEG);
      dL -=      381 * Math.sin((2*Mp - 2*F) * DEG);
      dL +=      351 * E  * Math.sin((D + M + Mp) * DEG);
      dL -=      340 * Math.sin((3*D - 2*Mp) * DEG);
      dL +=      330 * Math.sin((4*D - 3*Mp) * DEG);
      dL +=      327 * E  * Math.sin((2*D - M + 2*Mp) * DEG);
      dL -=      323 * E2 * Math.sin((2*M + Mp) * DEG);
      dL +=      299 * E  * Math.sin((D + M - Mp) * DEG);
      dL +=      294 * Math.sin((2*D + 3*Mp) * DEG);

      // Longitude vraie de la Lune
      var moonLon = ((Lp + dL / 1000000.0) % 360 + 360) % 360;

      // --- Longitude du Soleil (haute précision) ---
      var L0 = 280.46646 + 36000.76983 * T + 0.0003032 * T2;
      var Msun = M; // anomalie moyenne du Soleil déjà calculée
      var C = (1.914602 - 0.004817*T - 0.000014*T2) * Math.sin(Msun * DEG)
            + (0.019993 - 0.000101*T) * Math.sin(2*Msun * DEG)
            +  0.000289 * Math.sin(3*Msun * DEG);
      var sunLon = ((L0 + C) % 360 + 360) % 360;

      // --- Élongation géocentrique vraie ---
      var elongation = ((moonLon - sunLon) % 360 + 360) % 360;

      // Illumination (fraction 0–1)
      var illumination = (1.0 - Math.cos(elongation * DEG)) / 2.0;

      // Phase normalisée (0 = NL, 0.5 = PL)
      var phase = elongation / 360.0;

      // Âge lunaire depuis la dernière nouvelle lune
      var SYN = 29.53058867;
      var age = phase * SYN;

      return { age: age, illumination: illumination, phase: phase, elongation: elongation };
    }

    function getPhaseName(phase) {
      if (phase < 0.0255 || phase >= 0.9745) return 'Nouvelle Lune';
      if (phase < 0.2245)                    return 'Premier croissant';
      if (phase < 0.2755)                    return 'Premier quartier';
      if (phase < 0.4745)                    return 'Lune gibbeuse croissante';
      if (phase < 0.5255)                    return 'Pleine Lune';
      if (phase < 0.7245)                    return 'Lune gibbeuse décroissante';
      if (phase < 0.7755)                    return 'Dernier quartier';
      return 'Dernier croissant';
    }

    function drawMoon(phase) {
      var r = 90, cx = 100, cy = 100;
      if (phase < 0.02 || phase > 0.98) return '';
      if (phase > 0.48 && phase < 0.52) {
        return 'M ' + cx + ' ' + (cy-r) + ' A ' + r + ' ' + r + ' 0 1 1 ' + cx + ' ' + (cy+r) + ' A ' + r + ' ' + r + ' 0 1 1 ' + cx + ' ' + (cy-r) + ' Z';
      }
      var termRx = Math.abs(Math.cos(phase * 2 * Math.PI)) * r;
      var waxing = phase < 0.5;
      var termLargeArc = (phase > 0.25 && phase < 0.75) ? 1 : 0;
      if (waxing) {
        var termSweep = phase < 0.25 ? 0 : 1;
        return 'M ' + cx + ' ' + (cy-r) + ' A ' + r + ' ' + r + ' 0 1 1 ' + cx + ' ' + (cy+r) + ' A ' + termRx + ' ' + r + ' 0 ' + termLargeArc + ' ' + termSweep + ' ' + cx + ' ' + (cy-r);
      } else {
        var termSweep = phase < 0.75 ? 0 : 1;
        return 'M ' + cx + ' ' + (cy-r) + ' A ' + r + ' ' + r + ' 0 1 0 ' + cx + ' ' + (cy+r) + ' A ' + termRx + ' ' + r + ' 0 ' + termLargeArc + ' ' + termSweep + ' ' + cx + ' ' + (cy-r);
      }
    }

    function render(date) {
      var data = getMoonData(date);
      var pct  = data.illumination * 100;

      document.getElementById('moon-phase-name').textContent   = getPhaseName(data.phase);
      document.getElementById('moon-illumination').textContent = 'Illumination : ' + pct.toFixed(1) + ' %';
      document.getElementById('moon-age').textContent          = 'Âge : ' + data.age.toFixed(1) + ' jours';
      document.getElementById('moon-lit').setAttribute('d', drawMoon(data.phase));

      var glow = Math.round(data.illumination * 24);
      document.querySelector('.moon-picker__visual svg').style.filter =
        'drop-shadow(0 0 ' + glow + 'px rgba(245,230,200,' + (data.illumination * 0.6).toFixed(2) + '))';
    }

    function init() {
      var input = document.getElementById('moon-date-input');
      if (!input) return;

      var maxDate = new Date();
      maxDate.setFullYear(maxDate.getFullYear() + 5);
      input.max = maxDate.toISOString().split('T')[0];

      var today = new Date();
      input.value = today.toISOString().split('T')[0];
      render(today);

      input.addEventListener('change', function () {
        if (!this.value) return;
        var parts = this.value.split('-');
        render(new Date(+parts[0], +parts[1] - 1, +parts[2]));
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
